import { render, staticRenderFns } from "./ElementPopup.vue?vue&type=template&id=00a4ccbc&scoped=true"
import script from "./ElementPopup.vue?vue&type=script&lang=js"
export * from "./ElementPopup.vue?vue&type=script&lang=js"
import style0 from "./ElementPopup.vue?vue&type=style&index=0&id=00a4ccbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4ccbc",
  null
  
)

export default component.exports